import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c("template", { slot: "description" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("customer_insights.label.somos1_data_entry_desc")
                ) +
                " "
            ),
          ]),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: {
                    dense: "",
                    outlined: "",
                    loading: _vm.loading,
                    disabled: _vm.loading,
                  },
                  on: { click: _vm.downloadUsers },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("customer_insights.button.download")) + " "
                  ),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer_insights.button.filter")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  key: _vm.keyUsersTable,
                  ref: "dataTable",
                  staticClass: "text-center table-inca",
                  attrs: {
                    responsive: "",
                    hover: "",
                    items: _vm.filteredItems,
                    headers: _vm.headers,
                    "hide-default-footer": "",
                    "items-per-page": _vm.pagination.limit,
                    page: _vm.pagination.current,
                  },
                  on: {
                    pagination: _vm.handlePagination,
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDeleteUser(
                                                      item.user
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v("icon-delete"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Eliminar sección")])]
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.user.roles",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("div", [
                            _c(
                              "div",
                              _vm._l(item.user.roles, function (role, i) {
                                return _c(
                                  VChip,
                                  {
                                    key: i,
                                    staticClass: "mr-1 mb-1 text-lowercase",
                                    attrs: { small: "" },
                                  },
                                  [_vm._v(" " + _vm._s(role) + " ")]
                                )
                              }),
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
              ],
              1
            ),
            _c("dialogs-component", {
              ref: _vm.DIALOG_ADD_SECTION,
              attrs: { title: "Añadir user", width: 900 },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    var this$1 = this
                    return [
                      _c(
                        VForm,
                        {
                          ref: "formAddUser",
                          staticClass: "form mt-2",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "3" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Nombre")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "9" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      outlined: "",
                                      "hide-details": "auto",
                                      dense: "",
                                      rules: [
                                        function (v) {
                                          return (
                                            !!v ||
                                            this$1.translate("reglas.field")
                                          )
                                        },
                                      ],
                                    },
                                    model: {
                                      value: _vm.userToAdd,
                                      callback: function ($$v) {
                                        _vm.userToAdd = $$v
                                      },
                                      expression: "userToAdd",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "btnsRight",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onAddUser($event)
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { left: "" } }, [
                            _vm._v("icon-send"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VForm,
                  {
                    ref: "form",
                    staticClass: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VCard,
                      { staticClass: "filters-inca" },
                      [
                        _c(
                          VCardTitle,
                          {
                            staticClass: "pointer",
                            on: {
                              click: function ($event) {
                                _vm.collapse_filter = !_vm.collapse_filter
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("titles.search_filters")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          VCardText,
                          { staticClass: "pa-2 pt-0" },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "dense" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(VTextField, {
                                      attrs: {
                                        "append-icon": "mdi-magnify",
                                        label: "Buscar",
                                        "single-line": "",
                                        "hide-details": "",
                                        dense: "",
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.search,
                                        callback: function ($$v) {
                                          _vm.search = $$v
                                        },
                                        expression: "search",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }